module.exports = __webpack_public_path__ + "i-Tree_Pest-Predictor_metadata.pdf";